import { render, staticRenderFns } from "./BreakpointsSelection.vue?vue&type=template&id=654fde9b&"
import script from "./BreakpointsSelection.vue?vue&type=script&lang=ts&"
export * from "./BreakpointsSelection.vue?vue&type=script&lang=ts&"
import style0 from "./BreakpointsSelection.vue?vue&type=style&index=0&id=654fde9b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports